import './header-block-styles.scss'

const HeaderBlock = () => {

    return (
        <div className="header-block">
            <h2>RegExpConstructor</h2>
        </div>
    )
}

export default HeaderBlock